export default __webpack_public_path__ + "static/media/in-tg.e1a4ef83.svg";